<template>
  <div class="footer">
    <!-- 页面底部声明 -->
    <section>
      <ul class="statement" style='text-align:center;'>
        <template v-for="(item, index) in statement">
          <li :key="item.text">
            <router-link :to="item.to">
              <!--{{ $t(item.text) }}-->
              -
            </router-link>
          </li>
          <li :key="item.text + index">
            <span> | </span>
          </li>
        </template>
      </ul>
    </section>
    <section class="info">
      <p>{{ $t('ppj.address') }}</p><!--  在线客服电话 400-810-7272.不同地区的价格和产品会有所不同，部分区域可能无法提供外送服务. -->
      <p>{{ $t('ppj.phone') }}</p><!-- 北京总部地址：北京市丰台区恒泰中心写字楼A座18层 -->
      <p>
        {{ $t('ppj.copyright') }}
        <i>
          <a target="_blank" href="http://beian.miit.gov.cn">沪ICP备10208048号-1</a>
        </i>
      </p>
      <!--  ©版权所有：北京棒约翰餐饮发展有限公司。  -->
      <p>
        <a target="_blank" href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402001795'
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="http://51wm-pic1.oss-cn-hangzhou.aliyuncs.com/DMP/hnAzXZWt-bQpBtJwF-ZBGcSBbp-%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png"
               style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">沪公网安备 31010402001795号</p>
        </a>
      </p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'main-footer',
  data() {
    return {
      statement: [ // 信息声明菜单
        // {
        //   text: 'statement.careers',
        //   to: '/info-footer/careers',
        // },
        {
          text: 'statement.privacy',
          // to: '/info-footer/privacy',
          to: '',
        },
        // /info-footer/user
        {
          text: 'statement.user',
          to: '',
        },
        {
          text: 'statement.legal',
          // to: '/info-footer/legal',
          to: '',
        },
        // {
        //   text: 'statement.faq',
        //   to: '/info-footer/faq',
        // },
      ],
    };
  },
};

</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'
@import '../../assets/css/theme.sass'

.footer
  @include base-wrap
  text-align: center
  background: $bg_main
  padding: 0 14px
  overflow: hidden
  .statement
    padding: 18px 0 30px 0
    text-align: left
    border-bottom: 1px solid #fff
    li
      display: inline-block
      margin-right: 24px
      span
        color: #fff
      a
        color: #fff
        font-size: 14px
        text-decoration: none
  .info
    margin: 20px 0
    p
      color: #fff
      a
        color: #fff
      i
        font-style: initial
</style>
